import React, { useContext } from 'react';
import SecondaryNav from './SecondaryNav/SecondaryNav';
import {
	ApButtonTab,
	ApMenu,
	ApMenuItem,
	ApSecondaryNav,
	colors,
} from '@alixpartners/ui-components';
import { ContentDiv, FlexWrapper } from './SupplierDiversity.styles';
import APStats from './AlixPartnersStats/APStats';
import ExploreLibrary from './ExploreLibrary/ExploreLibrary';
import { VendorsByCategoryProvider } from 'contexts/SupplierDiversity/VendorsByCategoryProvider';
import { MultipleDiversityProvider } from 'contexts/SupplierDiversity/MultipleDiversityProvider';
import { AcrossUsaProvider } from 'contexts/SupplierDiversity/AcrossUsaProvider';
import { AnalyzeEditDataProvider } from 'contexts/SupplierDiversity/AnalyzeEditDataProvider';
import { ToastMessageProvider } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { DiversedSpendProvider } from 'contexts/SupplierDiversity/DiversedSpendProvider';
import { DiversedSuppliersProvider } from 'contexts/SupplierDiversity/DiversedSuppliersProvider';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { SettingsContext } from 'contexts/SettingsContext';
import {
	getCurrencySymbolFromOptions,
	SUPPLIER_DIVERSITY_ANALYZE_DATA_SUBMENU,
} from './utils';
import {
	useLocation,
	NavLink,
	Route,
	Switch,
	Redirect,
} from 'react-router-dom';
import EditData from './AnalyzeClientData/EditData/EditData';
import DiversityStats from './AnalyzeClientData/DiversityStats/DiversityStats';
import UploadData from './AnalyzeClientData/UploadData/UploadData';
import { ClientDataUploadHistoryProvider } from 'contexts/SupplierDiversity/ClientDataUploadHistoryProvider';
import PeriodSelect from 'Investigate/SecondaryNav/PeriodSelect';

const ContentComponent = {
	editData: EditData,
	diversityStats: DiversityStats,
	uploadData: UploadData,
	apStats: APStats,
	exploreLibrary: ExploreLibrary,
};

const SupplierDiversity = () => {
	const location = useLocation();
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const { currency } = useContext(QueryStringContext);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const { hideDecimals } = useContext(SettingsContext);

	return (
		<>
			<SecondaryNav />
			<FlexWrapper>
				<ApSecondaryNav
					left={
						<React.Fragment>
							{SUPPLIER_DIVERSITY_ANALYZE_DATA_SUBMENU.map(tab => {
								if ('path' in tab) {
									const { label, path } = tab;
									return (
										<NavLink to={path} key={path}>
											<ApButtonTab
												isSelected={location.pathname.includes(path)}
											>
												{label}
											</ApButtonTab>
										</NavLink>
									);
								} else {
									return (
										<ApMenu
											key={tab.label}
											toggleVariant="hover"
											button={
												<ApButtonTab
													toggleVariant="hover"
													isSelected={tab.child.some(
														child =>
															child.path === location.pathname ||
															location.pathname.includes(child.path)
													)}
												>
													{tab.label}
												</ApButtonTab>
											}
										>
											{tab.child.map(({ label, path }) => {
												return (
													<ApMenuItem
														key={label}
														style={{
															backgroundColor:
																path === location.pathname ||
																location.pathname.includes(path)
																	? colors.green0
																	: null,
														}}
													>
														<NavLink to={path} key={path}>
															{label}
														</NavLink>
													</ApMenuItem>
												);
											})}
										</ApMenu>
									);
								}
							})}
						</React.Fragment>
					}
					right={
						(location.pathname.split('/').includes('analyze-edit-data') ||
							location.pathname
								.split('/')
								.includes('supplier-diversity-stats')) && <PeriodSelect />
					}
				/>
			</FlexWrapper>
			<ToastMessageProvider>
				<VendorsByCategoryProvider>
					<AcrossUsaProvider>
						<MultipleDiversityProvider>
							<AnalyzeEditDataProvider
								currencySymbol={currencySymbol}
								hideDecimals={hideDecimals}
							>
								<DiversedSpendProvider
									currencySymbol={currencySymbol}
									hideDecimals={hideDecimals}
								>
									<DiversedSuppliersProvider>
										<ClientDataUploadHistoryProvider>
											<ContentDiv>
												<Switch>
													{SUPPLIER_DIVERSITY_ANALYZE_DATA_SUBMENU.flatMap(
														({ child }) => child
													).map(({ path, name }) => {
														return (
															<Route
																key={path}
																path={path}
																component={ContentComponent[name]}
															/>
														);
													})}
													<Redirect
														to={
															SUPPLIER_DIVERSITY_ANALYZE_DATA_SUBMENU[0]
																.child[0].path
														}
													/>
												</Switch>
											</ContentDiv>
										</ClientDataUploadHistoryProvider>
									</DiversedSuppliersProvider>
								</DiversedSpendProvider>
							</AnalyzeEditDataProvider>
						</MultipleDiversityProvider>
					</AcrossUsaProvider>
				</VendorsByCategoryProvider>
			</ToastMessageProvider>
		</>
	);
};

export default SupplierDiversity;
